import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Input, DatePicker, Select, Row, Col, message, AutoComplete, Popconfirm, Divider } from 'antd';
import 'antd/dist/antd.css';
import './styles.css';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import MaskedInput from 'react-input-mask'
import modalStatus from '../../redux/reducers/modalStatus';
import { instituicaoEncaminhamentoService } from '../../services/Instituicao-Encaminhamento-Service/instituicao-encaminhamento-service';
import { meioComunicacaoService } from '../../services/Meio-Comunicacao-Service/Meio-Comunicacao-Service';
import InputSelectMeioComunicacao from '../InputSelectMeioComunicacao';
import InputSelectInstituicaoEncaminhamento from '../InputSelectInstituicaoEncaminhamento';
import MaskedTextInput from 'react-text-mask'
import { maskTelefone, onKeyDownBloquearDigitosPorLength, validarTelefoneCelular } from '../../utils/telefone';
import InputSelectMunicipio from '../InputSelectMunicipio';

interface ModalAgendamentoInfoProps {
    modalStatus?: any,
    setAgendamentoInfoModal?: any,
    setRealizarAtendimento?: any,
    permissao?: any
}
const ModalAgendamentoInfo: React.FC<ModalAgendamentoInfoProps> = (prop) => {
    interface Agendamento {
        AgendamentoID?: number,
        Nome: string,
        PaisOrigem: string,
        DataHoraInicio: Date,
        // Duracao: number,
        Motivo: string,
        Telefone: string,
        DadosCadastraisID?: number,
        Situacao: string
    }
    interface DadosCadastrais {
        DadosCadastraisID?: number,
        Nome: string,
        PaisOrigem: string,
        DataNascimento: Date,
    }
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    let visible = prop.modalStatus[0].visibleAgendamentoInfo
    const { TextArea } = Input;
    const { Option } = Select;
    const [form] = Form.useForm();
    const [agendamentoSelecionado, setAgendamentoSelecionado] = useState<any>();
    const [optionsInput, setOptionsInput] = useState<any[]>();
    const [agendamentosDoDia, setAgendamentosDoDia] = useState<any[]>([])
    const [temProximoAgendamento, setTemProximoAgendamento] = useState<boolean>(false)
    const [temAgendamentoAnterior, setTemAgendamentoAnterior] = useState<boolean>(false)
    const [instituicaoEncaminhamentoInput, setInstituicaoEncaminhamentoInput] = useState<any[]>();
    const [perfilLogado, setPerfilLogado] = useState<number>()
    let time: any;
    const [situacoesInput, setSituacoesInput] = useState<any[]>();
    let option: any;
    var options: any[] = [];
    var situacoes: any[] = [];
    var agendamentosDoDiaComIdentificador: any[] = [];
    useEffect(() => {
        setPerfilLogado(parseInt(sessionStorage.getItem("grupoID") || ""))
        api.get(`Agendamento/getsituacoesagendamento`).then((response) => {
            situacoes = response.data;
            setSituacoesInput(situacoes)
        })
        instituicaoEncaminhamentoService.getAll().then(res => {
            if (res.status == 200)
                setInstituicaoEncaminhamentoInput(res.data)
        })
        form.resetFields();
        if (prop.modalStatus[0].agendamento != null) {
            setAgendamentoSelecionado(prop.modalStatus[0].agendamento)
            formSetFields(prop.modalStatus[0].agendamento)
        }
        if (prop.modalStatus[0].agendamentosDoDia != null) {
            agendamentosDoDiaComIdentificador = prop.modalStatus[0].agendamentosDoDia.filter((e: any) => e.agendamento).map((e: any) => e.agendamento)
            agendamentosDoDiaComIdentificador.map((a: any, i: any) => a.id = i);
            setAgendamentosDoDia(agendamentosDoDiaComIdentificador)
        }
    }, [prop.modalStatus[0].visibleAgendamentoInfo])
    useEffect(() => {
        if (agendamentoSelecionado != undefined) {
            formSetFields(agendamentoSelecionado)
        }
        if (agendamentosDoDia != undefined && agendamentoSelecionado != undefined) {
            let agendamentosAnteriores = getAgendamentosAnteriores();
            setTemAgendamentoAnterior(agendamentosAnteriores.length > 0)
            let agendamentosPosteriores = getProximosAgendamentos();
            setTemProximoAgendamento(agendamentosPosteriores.length > 0)
        }
    }, [agendamentoSelecionado])
    const formSetFields = (agendamento: any) => {
        let data = new Date(Date.parse(agendamento.dataHoraInicio)).toLocaleString();
        form.setFieldsValue({ dataAgendamento: data })
        form.setFieldsValue({ agendamentoID: agendamento.agendamentoID })
        form.setFieldsValue({ nome: agendamento.nome })
        form.setFieldsValue({ dadosCadastraisID: agendamento.dadosCadastraisID })
        // form.setFieldsValue({ duracao: agendamento.duracao })
        form.setFieldsValue({ motivo: agendamento.motivo })
        form.setFieldsValue({ situacao: agendamento.situacao })
        form.setFieldsValue({ telefone: agendamento.telefone == null ? "" : maskTelefone(agendamento.telefone.replace(/\W/g, '')) })
        form.setFieldsValue({ pais: agendamento.paisOrigem })
        form.setFieldsValue({ usuarioAgendamentoNome: agendamento.usuarioAgendamentoNome })
        form.setFieldsValue({ usuarioAgendamentoID: agendamento.usuarioAgendamentoID })
        form.setFieldsValue({ usuarioAtendimentoNome: agendamento.usuarioAtendimentoNome })
        form.setFieldsValue({ usuarioAtendimentoID: agendamento.usuarioAtendimentoID })
        form.setFieldsValue({ instituicaoEncaminhamentoID: agendamento.instituicaoEncaminhamentoID || null })
        form.setFieldsValue({ municipioID: agendamento.municipioID})
        form.setFieldsValue({ meioComunicacaoID: agendamento.meioComunicacaoID || null })
    }
    const handleCancel = () => {
        prop.setAgendamentoInfoModal(false);
    };
    const onSelect = (value: any, option: any) => {
        form.setFieldsValue({ pais: option.pais })
        form.setFieldsValue({ dadosCadastraisID: option.value })
        form.setFieldsValue({ nome: option.label })
    };
    const configOptions = (dados: any[]) => {
        dados.map((a: any) => {
            option = {
                value: a.dadosCadastraisID,
                label: a.nome + ' - ' + a.pais,
                pais: a.pais,
            }
            options.push(option)
        })
        setOptionsInput(options)
    }
    const buscarMigrante = (e: any) => {
        clearTimeout(time);
        time = setTimeout(() => {
            api.get(`DadosCadastrais/getbynome?nome=${e}`).then((response) => {
                configOptions(response.data)
            })
        }, 2000);
    }
    const ehRecepcao = () => {
        if (perfilLogado == 1446 || perfilLogado == 1447 || perfilLogado == 1448) {
            return true
        } else {
            return false
        }
    }
    const realizarCadastro = () => {
        history.push(`dados-cadastrais/cadastro/${agendamentoSelecionado.dadosCadastraisID}/agendamento/${agendamentoSelecionado.agendamentoID}/tabela/1`)
        prop.setAgendamentoInfoModal(false);
        prop.setRealizarAtendimento(true)
    }
    const disabledFieldByDate = () => {
        let date = form.getFieldValue('dataAgendamento')
        if (date != undefined && date != '' && date != null) {
            let dataFormatada = toISOFormat(date);
            let dataInicio = moment(new Date(dataFormatada)).add(240, 'minutes');
            return dataInicio.isBefore(moment(new Date(Date.now())))
        }
        return false
    }
    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [date, time] = dateTimeString?.split(' ');
        // Dividimos a data em dia, mês e ano:
        const [DD, MM, YYYY] = date?.split('/');
        // Dividimos o tempo em hora e minutos:
        const [HH, mm] = time?.split(':');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD} ${HH}:${mm}:00`;
    }
    const onFinish = (values: any) => {
        let dataFormatada = toISOFormat(values.dataAgendamento).replace(",", "");
        let dataInicio = new Date(dataFormatada);
        let result = moment(dataInicio).isValid();
        if (result) {
            api.put("Agendamento/alteratendimentosanteriores", {
                AgendamentoID: values.agendamentoID,
                Nome: values.nome,
                DataHoraInicio: moment(dataInicio).add(-4, 'hours'),
                // Duracao: values.duracao,
                PaisOrigem: values.pais,
                Motivo: values.motivo,
                Telefone: values.telefone,
                DadosCadastraisID: values.dadosCadastraisID,
                Situacao: values.situacao,
                InstituicaoEncaminhamentoID: values.instituicaoEncaminhamentoID,
                MeioComunicacaoID: values.meioComunicacaoID,
                MunicipioID: values.municipioID,
                UsuarioAgendamentoNome: values.usuarioAgendamentoNome,
                UsuarioAgendamentoID: values.usuarioAgendamentoID,
                UsuarioAtendimentoNome: values.usuarioAtendimentoNome,
                UsuarioAtendimentoID: values.usuarioAtendimentoID,
            })
                .then((response: any) => {
                    if (response.data.valido) {
                        message.success('Agendamento salvo com sucesso')
                    }
                    else {
                        message.error(response.data.error)
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    message.error('Falha na requisição')
                    setLoading(false);
                });
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
            }, 50);
        }
        else {
            message.error('Data Inválida')
        }
    };
    const onFinishFailed = (errorInfo: any) => {
    };
    const validarData = (_: any, value: { number: number }) => {
        let dataFormatada = toISOFormat(form.getFieldValue("dataAgendamento")).replace(",", "");
        let dataInicio = new Date(dataFormatada);
        let result = moment(dataInicio).isValid();
        if (result == false) {
            return Promise.reject(new Error('Data ou Hora inválida!'));
        }
        else if (moment(form.getFieldValue("dataAgendamento"), 'DD/MM/YYYY HH:mm', true).toDate() < new Date()) {
            return Promise.reject(new Error('A Data do Agendamento não pode ser menor que a data atual!'));
        }
        else {
            return Promise.resolve();
        }
    };
    function disabledDate(current: any) {
        return current < moment().endOf('day').subtract(1, 'day');
    }
    function disabledDateTime() {
        return {
            disabledHours: () => {
                let disabled = Array.from({ length: (24 - 0) }, (v, k) => k + 0).slice(0, 8)
                let fim = Array.from({ length: (24 - 0) }, (v, k) => k + 0).slice(18, 24)
                disabled = disabled.concat(fim)
                return disabled;
            },
        };
    }
    const getProximosAgendamentos = () => {
        return agendamentosDoDia.filter((e) => new Date(e.dataHoraInicio).getHours() > new Date(agendamentoSelecionado!.dataHoraInicio).getHours() ||
            new Date(e.dataHoraInicio).getHours() == new Date(agendamentoSelecionado!.dataHoraInicio).getHours() &&
            new Date(e.dataHoraInicio).getMinutes() > new Date(agendamentoSelecionado!.dataHoraInicio).getMinutes() ||
            (new Date(e.dataHoraInicio).getHours() == new Date(agendamentoSelecionado!.dataHoraInicio).getHours() &&
                new Date(e.dataHoraInicio).getMinutes() == new Date(agendamentoSelecionado!.dataHoraInicio).getMinutes() &&
                e.id == agendamentoSelecionado.id + 1
            )
        )
    }
    const getAgendamentosAnteriores = () => {
        return agendamentosDoDia.filter((e) => new Date(e.dataHoraInicio).getHours() < new Date(agendamentoSelecionado!.dataHoraInicio).getHours() ||
            new Date(e.dataHoraInicio).getHours() == new Date(agendamentoSelecionado!.dataHoraInicio).getHours() &&
            new Date(e.dataHoraInicio).getMinutes() < new Date(agendamentoSelecionado!.dataHoraInicio).getMinutes() ||
            (new Date(e.dataHoraInicio).getHours() == new Date(agendamentoSelecionado!.dataHoraInicio).getHours() &&
                new Date(e.dataHoraInicio).getMinutes() == new Date(agendamentoSelecionado!.dataHoraInicio).getMinutes() &&
                e.id == agendamentoSelecionado.id - 1
            )
        )
    }
    const sortVetorAgendamentosOrdemDecrescende = (vetor: any[]) => {
        vetor.sort((ant, prox) => {
            if (new Date(ant.dataHoraInicio).getHours() == new Date(prox!.dataHoraInicio).getHours() &&
                new Date(ant.dataHoraInicio).getMinutes() == new Date(prox!.dataHoraInicio).getMinutes() &&
                ant.id == prox.id - 1) {
                return -1;
            }
            else if (
                new Date(ant.dataHoraInicio).getHours() == new Date(prox!.dataHoraInicio).getHours() &&
                new Date(ant.dataHoraInicio).getMinutes() == new Date(prox!.dataHoraInicio).getMinutes() &&
                ant.id == prox.id + 1
            ) {
                return 1;
            }
            else {
                return 0;
            }
        })
    }
    const proximo = () => {
        let vetorAgendamentos = getProximosAgendamentos();
        sortVetorAgendamentosOrdemDecrescende(vetorAgendamentos);
        setTemProximoAgendamento(vetorAgendamentos.length > 0)
        setAgendamentoSelecionado(vetorAgendamentos[0])
    }
    const anterior = () => {
        let vetorAgendamentos = getAgendamentosAnteriores();
        sortVetorAgendamentosOrdemDecrescende(vetorAgendamentos);
        setTemAgendamentoAnterior(vetorAgendamentos.length > 0)
        setAgendamentoSelecionado(vetorAgendamentos[vetorAgendamentos.length - 1])
    }
    return (
        <Modal
            visible={visible}
            title=
            {prop.modalStatus[0].agendamentosDoDia !== null ?
                <Row>
                    <Col span={6}>
                        {temAgendamentoAnterior ? <Button type="default" onClick={anterior} block htmlType="button" >Anterior</Button> : null}
                    </Col>
                    <Col style={{ textAlign: 'center' }} span={10} >Agendamento </Col>
                    <Col span={6}>
                        {temProximoAgendamento ? <Button type="default" onClick={proximo} block htmlType="button" >Próximo</Button> : null}
                    </Col>
                </Row>
                : 'Agendamento'}
            onCancel={handleCancel}
            footer={null}
            width="700px"
        >
            <Form
                name="agendamento"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
            >
                <Form.Item
                    label="DadosCadastraisID"
                    name="dadosCadastraisID"
                    hidden={true}
                >
                    <Input type="number" hidden={true} />
                </Form.Item>
                <Form.Item
                    label="AgendamentoID"
                    name="agendamentoID"
                    hidden={true}
                >
                    <Input type="number" hidden={true} />
                </Form.Item>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Nome"
                            name="nome"
                        >
                            <AutoComplete
                                dropdownMatchSelectWidth={252}
                                options={optionsInput}
                                onSelect={onSelect}
                                onSearch={buscarMigrante}
                                disabled={disabledFieldByDate()}
                            >
                                <Input.Search size="middle" placeholder="Informe o Nome" enterButton required
                                />
                            </AutoComplete>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="País de Origem"
                            name="pais"
                        >
                            <Input placeholder="Informe o País do Migrante" disabled />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Telefone"
                            name="telefone"
                            rules={[{validator: (_, value) => validarTelefoneCelular(value), validateTrigger: "onSubmit"}]}
                        >                            
                            <MaskedTextInput
                                disabled={disabledFieldByDate()}
                                className="ant-input" onKeyDown={(e: any) => { onKeyDownBloquearDigitosPorLength(e, 11) }}                                
                                mask={(value: any) => {
                                    if (value && value.replace(/\D/g, '').length >= 11) {
                                        return [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                    } else {
                                        return [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Data e Hora"
                            name="dataAgendamento"
                            rules={[
                                {
                                    validator: validarData
                                }
                            ]}
                        >
                            <MaskedInput
                                disabled={disabledFieldByDate()}
                                className="ant-input" placeholder="Informe a Data e Hora" mask="99/99/9999 99:99" />
                            {/* <DatePicker disabledDate={disabledDate} disabledTime={disabledDateTime} placeholder="Selecione a Data" showTime style={{ width: '100%' }} format="DD/MM/YYYY HH:mm" /> */}
                        </Form.Item>
                    </Col>
                    {/* <Col className="gutter-row" span={8}>
                        <Form.Item
                            initialValue={15}
                            label="Duração"
                            name="duracao"
                        >
                            <Select placeholder="Minutos">
                                <Option value={15}>15min</Option>
                                <Option value={30}>30min</Option>
                                <Option value={45}>45min</Option>
                                <Option value={60}>60min</Option>
                            </Select>
                        </Form.Item>
                    </Col> */}
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Situação"
                            name="situacao"
                            initialValue="Aberto"
                        >
                            <Select placeholder="Situação">
                                {situacoesInput?.map(situacao => (
                                    situacao.enum != "Realizado" ?
                                        <Option key={situacao.enum} value={situacao.enum}>{situacao.enum}</Option>
                                        :
                                        null
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <InputSelectInstituicaoEncaminhamento instituicaoEncaminhamentoID={agendamentoSelecionado?.instituicaoEncaminhamentoID} visibleModal={prop.modalStatus} />
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <InputSelectMunicipio municipioID={agendamentoSelecionado?.municipioID} ehEdicao={true}/>
                        </Col>
                    </Row> 
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <InputSelectMeioComunicacao meioComunicacaoID={agendamentoSelecionado?.meioComunicacaoID} visibleModal={prop.modalStatus} ehEdicao={true} />
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Motivo"
                            name="motivo"
                        >
                            <TextArea maxLength={450} showCount rows={4}></TextArea>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Agendado por"
                            name="usuarioAgendamentoNome"
                        >
                            <Input placeholder="Usuario Nome" disabled />
                        </Form.Item>
                        <Form.Item hidden name="usuarioAgendamentoID" label="Usuário Agendamento">
                            <Input disabled></Input>
                        </Form.Item>
                    </Col>
                </Row>
                {form.getFieldValue('usuarioAtendimentoID') != 0 ?
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item name="usuarioAtendimentoNome" label="Atendido por" >
                                <Input disabled></Input>
                            </Form.Item>
                            <Form.Item hidden name="usuarioAtendimentoID" label="Usuário Atendimento">
                                <Input disabled></Input>
                            </Form.Item>
                        </Col>
                    </Row> :
                    null
                }
                <Form.Item>
                    {prop.permissao[0].permissaoAcesso?.editar === true ?
                        <Button className="button-alterar" type="primary" htmlType="submit">
                            Alterar
                        </Button>
                        : null}
                    {ehRecepcao() ? null : <Button className="button-alterar" type="dashed" htmlType="button" onClick={realizarCadastro}>
                        Realizar Atendimento
                    </Button>}
                </Form.Item>
            </Form>
        </Modal >
    );
}
const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})
const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}
export default connect(mapStateToProps, mapDispatcToProps)(ModalAgendamentoInfo);